import { isChrome } from '@/lib/utils';

const getProxiedAudioUrl = (audioUrl: string): string => {
  if (!isChrome()) return audioUrl;

  if (audioUrl.startsWith('/api/audio-proxy')) return audioUrl;

  try {
    const url =
      audioUrl.startsWith('http://') || audioUrl.startsWith('https://')
        ? new URL(audioUrl)
        : new URL(audioUrl, window.location.origin);

    return `/api/audio-proxy?url=${encodeURIComponent(url.toString())}`;
  } catch {
    return audioUrl;
  }
};

export default getProxiedAudioUrl;
